import daniil from "@/assets/authors/daniil-ischakis.png.asset.json";
import anders from "@/assets/authors/anders-gustafsson.jpg.asset.json";
import stratis from "@/assets/authors/stratis-karagiannis.png.asset.json";
import angela from "@/assets/authors/angela-lai.jpg.asset.json";

export const SITE_URL = "https://saased.co";
/** Canonical @id for Anders Gustafsson, shared by all JSON-LD graphs. */
export const ANDERS_ID = "https://saased.co/#anders-gustafsson";
/** Canonical @id for Angela Lai, shared by all JSON-LD graphs. */
export const ANGELA_ID = "https://saased.co/#angela-lai";
export const DEFAULT_AUTHOR = "SaaSed Team";

export type Author = {
  name: string;
  slug: string;
  role: string;
  bio: string;
  photo: string;
  linkedin: string;
};

export const AUTHORS: Author[] = [
  {
    name: "Daniil Ischakis",
    slug: "daniil-ischakis",
    role: "Marketing Executive",
    bio: "Daniil leads marketing at SaaSed, working on the content and campaigns that help enterprise buyers prepare for Salesforce renewals.",
    photo: daniil.url,
    linkedin: "https://www.linkedin.com/in/daniil-ischakis-10854b372",
  },
  {
    name: "Anders Gustafsson",
    slug: "anders-gustafsson",
    role: "Co-Founder & Salesforce expert",
    bio: "Anders is a Co-Founder of SaaSed.co and a Salesforce expert who spent eight years inside Salesforce.",
    photo: anders.url,
    linkedin: "https://www.linkedin.com/in/andersgustafsson1/",
  },
  {
    name: "Stratis Karagiannis",
    slug: "stratis-karagiannis",
    role: "Growth Manager",
    bio: "Stratis is Growth Manager at SaaSed, working on how enterprise buyers find and engage with the firm.",
    photo: stratis.url,
    linkedin: "https://www.linkedin.com/in/stratis-p-karagiannis/",
  },
  {
    name: "Angela Lai",
    slug: "angela-lai",
    role: "Co-Founder & CEO",
    bio: "Angela is a co-founder and the CEO of SaaSed.",
    photo: angela.url,
    linkedin: "https://www.linkedin.com/in/angelabolai/",
  },
];

const norm = (s: string) => s.trim().toLowerCase();

/** Match a post's author value (name or slug) to a known author. */
export function findAuthor(value: string | null | undefined): Author | null {
  if (!value?.trim()) return null;
  const v = norm(value);
  return AUTHORS.find((a) => norm(a.name) === v || a.slug === v) ?? null;
}

export function getAuthorBySlug(slug: string): Author | null {
  return AUTHORS.find((a) => a.slug === slug) ?? null;
}

/** Display name with fallback so empty values never break the page. */
export function authorDisplayName(value: string | null | undefined): string {
  return findAuthor(value)?.name ?? (value?.trim() || DEFAULT_AUTHOR);
}
